
export const $awsConfig = {
   "Auth": {
      "region": "us-east-1",
      "userPoolId": "us-east-1_l7vCIXjFZ",
      "userPoolWebClientId": "6lbipt0diiqb6m0vfci6ilkb97",
   },
}
